import { render } from "./Depoimentos.vue?vue&type=template&id=6f90e22a&scoped=true"
import script from "./Depoimentos.vue?vue&type=script&lang=js"
export * from "./Depoimentos.vue?vue&type=script&lang=js"

import "./Depoimentos.vue?vue&type=style&index=0&id=6f90e22a&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f90e22a"]])

export default __exports__